<script setup lang="ts">
import type { DashboardAccountHealth } from '@/types/models'

const props = defineProps<{
  account: DashboardAccountHealth
  snoozing: boolean
}>()

const emit = defineEmits<{
  snooze: [linkedinAccountId: string]
}>()
</script>

<template>
  <Card
    padding="lg"
    class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between"
  >
    <div class="flex items-start gap-4">
      <span class="material-symbols-outlined mt-1 text-outline">info</span>
      <div>
        <p class="font-serif text-on-surface">
          {{ props.account.display_name ?? 'This account' }} hasn't had a fresh LinkedIn export in over 6 months.
        </p>
        <p class="mt-1 text-ui-label text-on-surface-variant">
          Upload a fresh export to catch new connections and title changes.
        </p>
      </div>
    </div>
    <Button
      variant="secondary"
      class="shrink-0"
      :loading="props.snoozing"
      :disabled="props.snoozing"
      @click="emit('snooze', props.account.linkedin_account_id)"
    >
      {{ props.snoozing ? 'Snoozing…' : 'Snooze 30 days' }}
    </Button>
  </Card>
</template>
